<template>
  <div id="gloabl-event-catcher">
    <router-view></router-view>
  </div>
</template>

<script>
import NotificationSample from "src/pages/Dashboard/Components/NotificationSample";
import api from "./axios_api";
import swal from "sweetalert2";
import { components } from "aws-amplify-vue";

export default {
  components: {
    components
  },
  mounted() {
    const self = this;
    // start our portfolio interval
    self.$store.dispatch("arbiter/start");
    // start a repeat check to see if we need to log out (due to repeated api fails)
    setInterval(() => {
      self.forceLogout();
    }, 3000);
  },
  methods: {
    forceLogout() {
      const self = this;
      // show alert, restart and go to login page
      if (api.shouldForceLogout && self.$store.getters["user/hasToken"]) {
        swal({
          title: "Unable to Communicate with Server",
          buttonStyling: false,
          confirmButtonClass: "btn btn-danger btn-fill",
          text:
            "Unable to communicate with the remote server. You will be logged out, please wait a moment and try logging in again.",
          onClose: function() {
            self.$router.push("/login");
          }
        });
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch("arbiter/shutdown");
  }
};
</script>
<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
</style>
